export default "__VITE_ASSET__549ee3a4__"